import contractManage from './contractManage';
import accountManage from './accountManage';
import contractGroupManage from './contractGroupManage';
import customer from './customer';
import homePage from './homePage';
import leadManage from './leadManage';
const config = {
    ...contractManage,
    ...accountManage,
    ...contractGroupManage,
    ...customer,
    ...homePage,
    ...leadManage
};
export default config;
